import { render, staticRenderFns } from "./turnTablePrize.vue?vue&type=template&id=660da5de&scoped=true&"
import script from "./turnTablePrize.vue?vue&type=script&lang=ts&"
export * from "./turnTablePrize.vue?vue&type=script&lang=ts&"
import style0 from "./turnTablePrize.vue?vue&type=style&index=0&id=660da5de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660da5de",
  null
  
)

export default component.exports